import { gql } from '__generated__'

export const GET_DEMO_UP_DOWN_AI_QUOTA = gql(`
  query getDemoUpDownAiQuota {
    getDemoUpDownAiQuota {
      roundsPlayed
      roundsLeft
    }
  }
`)
